import { IgrFinancialCalculationDataSource } from './igr-financial-calculation-data-source';
import { IgrFinancialCalculationSupportingCalculations } from './igr-financial-calculation-supporting-calculations';
import { List$1 } from "igniteui-react-core";
import { String_$type } from "igniteui-react-core";
/**
 * Parameterizes a financial calculation event.
*/
var IgrFinancialEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrFinancialEventArgs() {
    }
    Object.defineProperty(IgrFinancialEventArgs.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrFinancialEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrFinancialEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrFinancialEventArgs.prototype, "basedOn", {
        get: function () {
            var ret = null;
            if (this.i.basedOn) {
                ret = [];
                for (var i = 0; i < this.i.basedOn.count; i++) {
                    ret.push(this.i.basedOn[i]);
                }
            }
            return ret;
        },
        set: function (v) {
            if (!v) {
                this.i.basedOn = null;
                return;
            }
            var list = new List$1(String_$type, 0);
            for (var i = 0; i < v.length; i++) {
                list.add(v[i]);
            }
            this.i.basedOn = list;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrFinancialEventArgs.prototype, "position", {
        /**
     * The beginning position that should be calculated from.
    */
        get: function () {
            return this.i.position;
        },
        set: function (v) {
            this.i.position = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrFinancialEventArgs.prototype, "count", {
        /**
         * The number of positions that should be calculated from the start.
        */
        get: function () {
            return this.i.count;
        },
        set: function (v) {
            this.i.count = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrFinancialEventArgs.prototype, "dataSource", {
        /**
         * The data to use for the calculation.
        */
        get: function () {
            var r = this.i.dataSource;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrFinancialCalculationDataSource();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        set: function (v) {
            v == null ? this.i.dataSource = null : this.i.dataSource = v.i;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrFinancialEventArgs.prototype, "supportingCalculations", {
        /**
         * The supporting calculations to use in the calculation.
        */
        get: function () {
            var r = this.i.supportingCalculations;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrFinancialCalculationSupportingCalculations();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        set: function (v) {
            v == null ? this.i.supportingCalculations = null : this.i.supportingCalculations = v.i;
        },
        enumerable: false,
        configurable: true
    });
    return IgrFinancialEventArgs;
}());
export { IgrFinancialEventArgs };
